import React from "react";
import "./label.sass";

export interface ILabelProps {
  text: string;
  isRequired: boolean;
}

const Label: React.FC<ILabelProps> = ({text, isRequired}) => {
  return (
    <label className="label" data-testid={text}>
      {text}
      {isRequired && "*"}
    </label>
  );
};

export default Label;
